export default __webpack_public_path__ + "static/media/Green0001.649ef09e.png";